import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col } from 'antd';
import { withRouter } from 'react-router-dom';

@withRouter
@inject('store')
@observer
export class StatusPanel extends Component {
    render() {
        const { config } = this.props.store.odysseyBotStore;
        return (
            <div className="status-panel">
                <div className={'inner'}>
                    <Row gutter={24}>
                        <Col xs={24} sm={12}>
                            <div style={{ display: 'inline-block', marginRight: 10 }}>
                                <img
                                    height="32px"
                                    style={{ marginTop: 6, marginRight: 10 }}
                                    src={`/exchanges/bybit.png`}
                                    alt="bybit exchange logo"
                                />
                                <span style={{ fontSize: 16, position: 'relative', top: 4 }}>
                                    {config.name}
                                </span>
                            </div>
                        </Col>
                    </Row>
                    {this.props.children}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/OdysseyBot/StatusPanel.js